import enGB from './en_GB.json';
import frFR from './fr_FR.json';
import itIT from './it_IT.json';
import deDE from './de_DE.json';
import esES from './es_ES.json';
import nlNL from './nl_NL.json';

const locales = {
    en_GB: enGB,
    es_ES: esES,
    fr_FR: frFR,
    it_IT: itIT,
    de_DE: deDE,
    nl_NL: nlNL,
};

export default locales;
